<template>
  <b-container>
    <b-table :items="myreviews" :fields="fields">
      <template #cell(rating)="row">
        <star-rating v-if="hasbeenrated(row)" :read-only="true" v-bind:increment="0.5" v-bind:star-size="30" v-model="row.item.rating"></star-rating>
        <font-awesome-icon v-else icon="times" style="color: red" />
      </template>
      <template #cell(reviewer_id)="row">
        <p v-html="userinfo(row)" />
      </template>
      <template #cell(sent)="row">
        {{ dateToNL(row.item.sent) }}
      </template>
      <template #cell(actions)="row">
        <a v-if="hasbeenrated(row)" href="javascript:;" class="action-item" @click="showreview(row)">
          <font-awesome-icon icon="eye" />
        </a>
        <a v-if="hasbeenrated(row)" href="javascript:;" class="action-item" @click="showreview(row)">
          <font-awesome-icon icon="trash" />
        </a>
      </template>
    </b-table>
    <BSShowReviewModal :reviewsend_id="reviewsend_id" />
  </b-container>
</template>
<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import StarRating from "vue-star-rating";
import BSShowReviewModal from "../BSShowReviewModal";

export default {
  name: "userreviewsscreen",
  data() {
    return {
      tag_id: null,
      selectedtag: null,
      reviews: null,
      reviewssend: null,
      reviewrequest: null,
      reviewsend_id: null,
    };
  },
  async mounted() {
    console.log("mounted ");
    await axios.get("/api/reviewssend/all").then((response) => {
      this.reviewssend = response.data;
    });
    await axios.get("/api/reviewrequest/all").then((response) => {
      this.reviewrequest = response.data;
    });

    await axios.get("/api/review/all").then((response) => {
      this.reviews = response.data;
    });
  },
  props: {
    user_id: Number,
  },
  computed: {
    fields() {
      return [
        { key: "sent", label: this.$i18n.t("labels.datecreated") },
        { key: "reviewer_id", label: this.$i18n.t("labels.name"), sortable: true, sortDirection: "desc" },
        { key: "rating", label: this.$i18n.t("tableheaders.rating") },
        { key: "actions", label: this.$i18n.t("labels.actions") },
      ];
    },
    myreviews() {
      if (this.reviewssend && this.reviews && this.reviewrequest) {
        this.reviewssend.forEach((review) => {
          let ranking = 0;
          let ratingquestioncount = 0;
          this.reviewrequest
            .filter((rq) => rq.id == review.request_id)
            .forEach((rr) => {
              JSON.parse(rr.questions).forEach((q) => {
                let score = this.reviews.filter((re) => re.question_id == q && re.signer_id == review.reviewer_id)[0];
                if (score && parseFloat(score.rating) > 0) {
                  ranking += score.rating;
                  ratingquestioncount++;
                }
              });
            });
          review.rating = ranking / ratingquestioncount;
        });
      }
      return this.reviewssend ? this.reviewssend.filter((rs) => rs.user_id == this.user_id && rs.reviewer_id != null) : [];
    },
    user() {
      return this.user_id > 0 ? this.user_by_id(this.user_id) : this.user_new;
    },
    ...mapGetters(["user_metas", "user_by_id", "activebranches", "user_new", "tag_by_id", "username_by_id"]),
    ...mapState(["users", "branches", "avatars", "contracts", "tags", "planning"]),
  },
  methods: {
    userinfo(row) {
      if (row.item.contract_id != 0) {
        let project = this.project_by_id(this.contract_by_id(row.item.contract_id).project_id);
        let company = this.company_by_id(project.company_id);
        let companyline = "<strong>" + this.$i18n.t("labels.companyname") + "</strong>  " + company.company_name + "<br/>";
        let projectline = "<strong>" + this.$i18n.t("labels.project") + "</strong>  " + project.title + "<br/>";
        let reviewline = "<strong>" + this.$i18n.t("labels.contactperson") + "</strong>  " + this.username_by_id(row.item.reviewer_id) + "<br/>";
        return companyline + projectline + reviewline;
      }
      return "Eigen Evaluatie";
    },
    contactname(row) {
      // console.log("name",row.item)
      if (row.item && this.contracts.filter((c) => c.id == row.item.contract_id).length > 0) {
        if (this.planning.filter((p) => p.id == this.contracts.filter((c) => c.id == row.item.contract_id)[0].planning_id).length > 0 && this.contracts.filter((c) => c.id == row.item.contract_id)[0].planning_id) {
          return this.planning.filter((p) => p.id == this.contracts.filter((c) => c.id == row.item.contract_id)[0].planning_id)[0].project_name;
        } else {
          return " ";
        }
      } else {
        return "";
      }
    },
    hasbeenrated(row) {
      return this.reviews.filter((r) => r.review_id == row.item.id).length > 0;
    },
    showreview(row) {
      console.log("", row);
      this.reviewsend_id = row.item ? row.item.id : row.id;

      this.$bvModal.show("BSShowReviewModalID");
    },
  },
  components: { StarRating, BSShowReviewModal },
};
</script>
